// TransitionWrapper.jsx
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const TransitionWrapper = ({ children }) => {
  const location = useLocation();
  const [className, setClassName] = useState('page-enter');

  useEffect(() => {
    requestAnimationFrame(() => {
      setClassName('page-enter-active');
    });
    return () => {
      setClassName('page-exit');
      setTimeout(() => setClassName('page-exit-active'), 10);
    };
  }, [location.pathname]);

  return <div className={`transition-container ${className}`}>{children}</div>;
};

export default TransitionWrapper;